function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import "core-js/modules/es6.string.starts-with.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.date.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.object.set-prototype-of.js";
import "core-js/modules/es6.object.get-prototype-of.js";
import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.create.js";
import "core-js/modules/es6.object.define-property.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.is-array.js";
import "regenerator-runtime/runtime.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/*jshint esversion: 8 */
import { ComponentBase } from "./Shared/ComponentBase";
import { OAuthService } from "./Services/OAuthService";
import { UserService } from "./Services/UserService";
import { I18N } from "./Shared/I18n";
export var MppUserLogin = /*#__PURE__*/function (_ComponentBase) {
  _inherits(MppUserLogin, _ComponentBase);

  var _super = _createSuper(MppUserLogin);

  function MppUserLogin() {
    _classCallCheck(this, MppUserLogin);

    return _super.call(this);
  }

  _createClass(MppUserLogin, [{
    key: "LoadChildren",
    value: function () {
      var _LoadChildren = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _iterator, _step, item, $li;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!!this._$securedMenuItemList) {
                  //Remove all items except first two (logout link, user account link):
                  while (this._$securedMenuItemList.children.length > 2) {
                    this._$securedMenuItemList.removeChild(this._$securedMenuItemList.lastChild);
                  } //Populate menu lists with child elements:


                  _iterator = _createForOfIteratorHelper(this.children);

                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      item = _step.value;
                      $li = document.createElement("li");
                      $li.setAttribute("class", "mppw-login--list-item");
                      $li.appendChild(item.cloneNode(true));

                      this._$securedMenuItemList.appendChild($li.cloneNode(true));
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function LoadChildren() {
        return _LoadChildren.apply(this, arguments);
      }

      return LoadChildren;
    }()
  }, {
    key: "createI18N",
    value: function createI18N() {
      return new I18N(MppUserLogin.WidgetDetails.tag);
    }
  }, {
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this = this;

        var i18n, observer;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.createI18N();

              case 3:
                i18n = _context2.sent;
                _context2.next = 10;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](0);

                if (_context2.t0.toString().startsWith("TypeError")) {
                  this._root.innerHTML = "Unable to connect.  Please check Permitted URLs.";
                } else {
                  this._root.innerHTML = "".concat(_context2.t0);
                }

                return _context2.abrupt("return");

              case 10:
                this._root.innerHTML = "\n\t\t\t<link href=\"".concat(this._appRoot, "/Content/mppw-widgetstyles.css\" rel=\"stylesheet\" type=\"text/css\" />\n\t\t\t<div class=\"mppw-component-container mppw-login\">\n\t\t\t\t<a href=\"#\" id=\"loginButton\" class=\"mppw-loggedout--username\" style=\"display: none\">\n\t\t\t\t\t<div class=\"mppw-icon-unlock\"></div>\n\t\t\t\t\t<span class=\"mppw-loggedout--label\">").concat(i18n.loginButtonLabel, "</span>\n\t\t\t\t</a>\n\t\t\t\t<a href=\"#\" id=\"userNameContainer\" class=\"mppw-login--container\" style=\"display: none;\">\n\t\t\t\t\t<div id=\"userImage\" class=\"mppw-user-photo\"></div>\n\t\t\t\t\t<div id=\"userDisplayName\" class=\"mppw-login--username\">").concat(i18n.loginButtonLabel, "</div>\n\t\t\t\t</a>\n\t\t\t\t<div id=\"userMenu\" class=\"mppw-login--dropdown\" style=\"display: none;\">\n\t\t\t\t\t<div id=\"securedMenuItems\" style=\"display: none;\">\n\t\t\t\t\t\t<ul class=\"mppw-login--list\" id=\"securedMenuItemList\">\n\t\t\t\t\t\t\t<li class=\"mppw-login--list-item\"><a id=\"logoutButton\">").concat(i18n.logoutButtonLabel, "</a></li>\n\t\t\t\t\t\t\t<li class=\"mppw-login--list-item\"><a id=\"userAccountLink\" href=\"#\">").concat(i18n.userAccountLabel, "</a></li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t");
                this._$userNameContainer = this._root.querySelector("#userNameContainer");
                this._$userImage = this._root.querySelector("#userImage");
                this._$userDisplayName = this._root.querySelector("#userDisplayName");
                this._$userMenu = this._root.querySelector("#userMenu");
                this._$securedMenuItems = this._root.querySelector("#securedMenuItems");
                this._$securedMenuItemList = this._root.querySelector("#securedMenuItemList");
                this._$loginButton = this._root.querySelector("#loginButton");
                this._$logoutButton = this._root.querySelector("#logoutButton");
                this._$createAccountLink = this._root.querySelector("#createAccountLink");
                this._$userAccountLink = this._root.querySelector("#userAccountLink");
                this.LoadChildren(); //TODO: check local/session storage for token to determine if user is logged in
                //Manually displaying login button for now:
                //this._$loginButton.style.display = "";

                this._$loginButton.addEventListener("click", function (event) {
                  event.preventDefault();
                  OAuthService.SignIn();
                });

                this._$logoutButton.addEventListener("click", function (event) {
                  event.preventDefault();
                  OAuthService.SignOut();
                });

                this._$userNameContainer.addEventListener("click", function (e) {
                  e.preventDefault();
                  var userMenuDisplay = _this._$userMenu.style.display;
                  _this._$userMenu.style.display = userMenuDisplay === "block" ? "none" : "block";
                });

                UserService.GetCurrentUser().then(function (userInfo) {
                  return _this.SetDisplayMode(userInfo);
                }, function () {
                  return _this.SetDisplayMode();
                });
                observer = new MutationObserver(function () {
                  _this.LoadChildren();
                });
                observer.observe(this, {
                  childList: true,
                  subtree: true
                });

              case 28:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 6]]);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }()
  }, {
    key: "SetDisplayMode",
    value: function SetDisplayMode(userInfo) {
      if (!!userInfo) {
        if (!!userInfo.imageUrl) {
          this._$userImage.setAttribute("style", "background-image: url('".concat(userInfo.imageUrl, "?thumbnail=true');"));
        } else {
          this._$userImage.classList.remove("mppw-icon-unlock");

          this._$userImage.classList.add("mppw-icon-user-circle");
        }

        this._$userNameContainer.style.display = "";

        if (!!userInfo.user) {
          this._$userDisplayName.innerHTML = (userInfo.user.nickname || userInfo.user.firstName) + ' ' + userInfo.user.lastName;
          this._$securedMenuItems.style.display = "";

          this._$userAccountLink.setAttribute("href", userInfo.profileUrl + "?profile");
        }

        this._$loginButton.style.display = "none";
      } else {
        this._$userImage.classList.remove("mppw-icon-user-circle");

        this._$userImage.classList.remove("mppw-user-photo");

        this._$userImage.classList.add("mppw-icon-unlock");

        this._$securedMenuItems.style.display = "none";
        this._$userNameContainer.style.display = "none";
        this._$loginButton.style.display = "";
      }
    }
  }], [{
    key: "WidgetDetails",
    get: function get() {
      return {
        name: "User Login",
        tag: "mpp-user-login",
        configurationItems: [{
          name: "Menu Urls",
          attribute: "userUrls",
          description: "Optional Url Menu Items to show with widget.Similar to &lt;a href=\"https://example.com/mylink\"&gt;info&lt;/a&gt;",
          required: false,
          type: "innerHTML"
        }]
      };
    }
  }]);

  return MppUserLogin;
}(ComponentBase);
MppUserLogin.registerComponent(MppUserLogin.WidgetDetails.tag, MppUserLogin);